import React from 'react'
import styled from 'styled-components';
import MainPanel from '../components/common/MainPanel'
import JustifyMenu from '../components/common/styled/JustifyMenu'
import NftImg from '../assets/img/nft_cover.png'
import Mainbg from '../components/common/styled/Mainbg';
import {BoxItemEmpty} from '../components/common/styled/BoxItem'
import NFTBoxItem from '../components/nft/NFTBoxItem'

const NFTMain = styled.div`
  width: 1080px;
  margin: 0 auto;
  padding: 60px 0;
  .main-panel {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`;

export default function TriasNFT() {
  const listdata = [
    {
      img: '',
      title: 'Land of the Lost',
      desc: 'Land of the Lost is a mysterious and dinosaur dominated land, whose borders are intertwined, so anyone who traveling towards one direction will end up in an endless cycle. The only way out is to compound metals extracted from particular mine to form a special weapon to disentangle the twisted world.',
      url: '#/nftdetail',
    }
  ];
  return (
    <>
      <MainPanel IntroImg={NftImg}>
        <div className="desc mt30">
          <p>Trias NFT is a platform for NFT casting, exhibition, trading, storage, etc., as well as a crucial parts of the NFT ecology. Trias technology empowers NFTs to be exchanged and auctioned in a safer and more transparent way. In addition, Trias DAO encourages art collections to be created and distributed in a fair way, benefiting artists, collectors and the public.</p>
          <p>On Trias NFT, users can mine and invest in NFTs , while artists and creators can initiate NFT programs on Trias Grant and mint, exhibit, and sell their NFT works. Trias-related art works and memes are more than welcome.</p>
        </div>
      </MainPanel>
      <Mainbg>
        <NFTMain>
          <JustifyMenu>
            <h2 className="h2">NFT Collections</h2>
            <a href='#/triasnft'>
              View all collections
              <i className="fa fa-arrow-right"></i>
            </a>
          </JustifyMenu>

          <div className="main-panel">
            {
              listdata.map((item, index)=> <NFTBoxItem key={index} {...item}></NFTBoxItem>)
            }
            <BoxItemEmpty>stay tuned</BoxItemEmpty>
          </div>
        </NFTMain>
      </Mainbg>
    </>
  )
}
